import moment from "moment";

// export interface ITimelineItem {
//     id: string;
//     title: string;
//     channel: {
//         id: string;
//         title: string;
//     };
//     playlist: {
//         id: string;
//         title: string;
//         startTime: string;
//     },
//     startTime: string;
//     startMode: 'follow' | 'fixed';
//     editor: string;
//     duration: number;
//     submittedAt: string;
//     status: string;
//     serviceRefID: string;
// }

export interface TimelimeChannel {
    id: string;
    title: string;
    channelType: string;
    monitorPreviewURL?: string;
    monitorPreviewType?: 'stream' | 'image';
}

export interface IDrawEvent { startTime: string; endTime: string; channel: string; channelIds?: string[]; snapValue: number; }
export const emptyDrawEvent: IDrawEvent = { startTime: null, endTime: null, channel: null, channelIds: [], snapValue: 5 }
export type IItemsSize = 'sm' | 'normal' | 'lg' | 'xl';


export interface ITimelineItem {
    id: string;
    title: string;
    start: string;
    end?: string;
    length: number;
    playlistLength: number;
    channel: string;
    isBackup?: boolean;
    lastSubmit?: string;
    status: string;
    options: ITimelineItemOptions;
}

export interface ITimelineItemOptions {
    items?: ITimelineItem[];
    itemType?: string;
    [key: string]: any;
}

export const emptyTimelineItem: ITimelineItem = {
    id: "new_0",
    length: 0,
    playlistLength: 0,
    title: 'New Event',
    channel: null,
    start: moment().toISOString(),
    status: '',
    lastSubmit: null,
    options: {},
}

export type IRecordServiceType = 'streamUrl' | 'blackMagic';

export interface IMonitor {
    id: string;
    title: string;
    ip: string;
    recordServiceType: IRecordServiceType;
    metadata?: any;
    isRecordable?: boolean;
    isMonitorable?: boolean;
    isRecording?: boolean;
    isUrlChangeable: boolean;
}

export type IViewMode = 'calendar' | 'list';
export type ICalendarViewMode = 'month' | 'day';
export const emptyDrawRecord: IDrawEvent = {startTime: null, endTime: null, channel: null, channelIds: [], snapValue: 5}
export interface IRecord {
  id: string;
  title: string;
  monitor: string;
  metadata: IRecordMetadata;
  startedAt: string;
  endedAt: string;
  status: number;
  creator: string;
  updatedAt: string;
}

export interface IRecordMetadata {
    [key: string]: any;
}

export const emptyRecord: IRecord = {
  id: "new_0",
  title: "New Record",
  monitor: null,
  metadata: {},
  status: 0,
  startedAt: "",
  endedAt: "",
  creator: "",
  updatedAt: "",
}
